import { CohortModel } from '@/models/cohort/cohort';

export class CohortSerializer {

    private static INSTANCE = new CohortSerializer();

    static get instance() {
        return this.INSTANCE;
    }

    public normalizeCohortList(payload: any) {
        const groups = payload.groups ? payload.groups : [];
        const cohortList: CohortModel[] = [];

        groups.forEach((item: any) => {
            const group: CohortModel = {
                id: item.id,
                name: item.name,
                parentId: item.parent_id,
                referenceId: item.reference_id,
            };
            cohortList.push(group);
        });

        return cohortList;
    }

    public normalizeACLDemoList(payload: any) {
        const aclPayload = payload.ACL ? payload.ACL : [];
        const acl: any = {
            aclByType: {},
            aclList: aclPayload,
        };
        acl.aclByType = aclPayload.reduce((r: any, a: any) => {
            r[a.type] = r[a.type] || [];
            r[a.type].push(a);
            return r;
        }, Object.create(null));
        return acl;
    }

}

export const cohortSerilaizer = CohortSerializer.instance;
